import { createRouter as createRouterLegacy, createWebHistory } from "vue-router";
import { setupLayouts } from "virtual:generated-layouts";
import { useAuthStore } from "@/stores/authStore";
import { useSettingsStore } from "@/stores/settingsStore";
import { routes } from "vue-router/auto-routes";

/**
 *
 * @returns {import("vue-router").Router}
 */
export function createRouter() {
  const router = createRouterLegacy({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes: setupLayouts(routes),
  });

  router.beforeEach(async (to) => {
    const authStore = useAuthStore();
    if (isPublicPath(to)) {
      return true;
    }
    if (!authStore.me) {
      try {
        await authStore.authenticate();
      } catch (error) {
        // `who-am-i` refuse les comptes sans droit payment. Les renvoyer au SSO les ferait revenir ici en boucle : on les
        // rend à leur espace fundraising, dont le login redirige vers leur compte utilisateur ou association.
        if (error?.name === "ForbiddenError") {
          window.location.href = `${useSettingsStore().settings.fundraisingBaseUrl}/login`;
        }
        return false;
      }
    }
    if (!authStore.me?.active) {
      window.location.href = `${useSettingsStore().settings.loginUrl}?redirectUrl=${window.location.href}`;
      return false;
    }
    return requiresAdmin(to) && !authStore.isSuperAdmin ? "/unauthorized" : true;
  });

  return router;
}

const isPublicPath = (to) => {
  for (let i = to.matched.length - 1; i >= 0; i--) {
    if (to.matched[i].meta.public !== undefined) {
      return to.matched[i].meta.public;
    }
  }
  return null;
};

const requiresAdmin = (to) => to.matched.some((record) => record.meta.admin);
